export default __webpack_public_path__ + "static/media/AlaskaAirlinesLogo.b1472af6.png";